import { LoyaltyApi } from "@jti/rest-api";

import { TAGS } from "../common/tags";
import type { LoyaltyApiBuilder } from "../loyaltyApi.types";

export const getLoyaltyStatusEndpoint = (builder: LoyaltyApiBuilder) => ({
  getLoyaltyStatus: builder.query<boolean, void>({
    queryFn: async () => {
      const loyaltyApi = LoyaltyApi.init();
      const isActive = await loyaltyApi.getStatus();
      return { data: isActive };
    },
    providesTags: [TAGS.LOYALTY_STATUS],
  }),
});
